var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatiala01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill:#fff;stroke:#000;stroke-miterlimit:10;}.cls-1{stroke-width:2px;}.cls-2{stroke-width:1.98px;}.cls-3{stroke-width:0.99px;}.cls-4{stroke-width:1.81px;}.cls-5{stroke-width:1.87px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.77,149.55a276.58,276.58,0,0,0,53.3,2.31c36.48-2,54.73-3,58-3.85,6-1.59,17.72-5.17,23.34.38,2.42,2.39,2.6,5.36,3.12,9.26,2.53,19.12,5.81,20.76,7.36,36,1.14,11.16.35,19.24,0,25.3-2,38.2-3,54.44-11.67,106.45-4.19,25-8.8,53.88-22.89,94.25-10.11-2.32-23,.62-33.14-1.69a247.39,247.39,0,0,1-6.61-34.33c-4.25-35.4,1.81-50.33,1.17-92.95-.43-28-3.55-55.56-5.45-55.53s-3.18,29.91-3.5,46.66c-.49,25.69.7,42.9,0,78.3a154.76,154.76,0,0,1-3.89,33.55,150.8,150.8,0,0,1-7.39,23.14L163.61,418A845,845,0,0,1,141.83,306.9c-3.36-26.5-12.3-53.27-11.14-88.9C131.61,190,140.61,166.75,143.77,149.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.33,98.83c-10,12-9.74,27.39-9.33,42.17.1,3.55-.35,4.28.59,10.76a281.76,281.76,0,0,0,75.67,8.5,281.18,281.18,0,0,0,61.5-8.34,145.14,145.14,0,0,0-2.43-25.75c-2.94-16.55-4.41-24.83-9.5-29.5-9.34-8.6-19.56.67-47.83,0-32.24-.77-51.13-13.6-65.33-1.34A27.31,27.31,0,0,0,152.33,98.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,162.53c8.74,23,6.42,49.93-5.65,71.35-3.82,7-9.39,13.82-8.44,22.24-1-4,0-8.27,1.55-12.05s3.68-7.34,5.51-10.93a93.5,93.5,0,0,0,8.21-22.65,99.06,99.06,0,0,0-1.18-48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.79,161.23c5.65,21,10.42,44.66.15,65.06-4.81,10.08-11.5,18.91-16.93,28.4a116.46,116.46,0,0,0-12.07,30.47,100.93,100.93,0,0,1,10.7-31.23c7.8-14.48,18.72-27.41,21.59-43.87,2.92-16.27-.47-32.79-3.44-48.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.22,156.29c1.74,6.74,3.36,13.51,5,20.26,2.3,10.17,5.44,20.36,5.65,30.9.48,25.53-18.78,45.19-33.91,63.49-8.77,10.66-16.94,22.31-20.24,35.91,5.31-28.24,30.43-46.15,43.91-70.15,5.12-8.87,8.66-18.9,8.52-29.23s-2.84-20.51-4.88-30.71c-1.36-6.82-2.79-13.63-4.09-20.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.28,157.16c11.83,30.46,12.24,66.56-4.23,95.45-12.31,21.5-33.17,36.23-46.46,57a69.5,69.5,0,0,0-9.8,22.26c4.54-24.8,24.37-42.46,40.22-60.6,29.31-31.6,33.44-74.2,20.27-114.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.39,249.87c-4.8,20.6-15.05,42.94-30.19,58-7.9,7.59-17.14,13.73-23.82,22.43-3.3,4.3-6.07,9-9.11,13.63s-6.39,9.07-10.75,12.45a55.43,55.43,0,0,0,9.92-13c2.82-4.69,5.41-9.55,8.69-14,6.49-9,15.83-15.33,23.68-22.94,14.85-14.69,25.41-36.74,31.58-56.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.58,162.22c-2.71,7.61,3.06,14.15,6.43,20.49a42.32,42.32,0,0,1,2.81,7.17c2.66,9.9,1.79,20.21.24,30.17-.07-9.93.5-20-2.17-29.63-1.91-9.37-12.4-18.26-7.31-28.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,161.32c-1.47.82-1.33,2.69-1.48,4.15l-.28,4.69c-.5,9.31-1.09,18.73-.95,28,.07,6.26,3,11.83,5.09,17.63q3.33,8.79,6.31,17.71-4.06-8.49-7.76-17.12c-2.41-5.81-5.54-11.68-5.64-18.13a197.32,197.32,0,0,1,2-28.22l.73-4.65c.25-1.44.41-3.48,2-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.12,160c-6.79,18.84-13.82,40.14-5.45,59.52,4.07,9.33,12.19,17.22,14,27.62,1.78,9.7.45,22.18,10.39,27.59-10.4-4.58-10-17.86-11.92-27.27-2.18-10.3-10.1-17.61-14.27-27.14-8.57-19.82-1.12-41.82,7.28-60.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.53,164.55c-2.18,12.06-2.17,24.3-2,36.5.22,9.11-.09,18.27,2.14,27.12a53.56,53.56,0,0,0,3,8.48c2.86,6.08,17,36,19.46,41.47,3.8,8.2,7.88,16.82,15.67,22-8.16-4.63-12.77-13.32-16.85-21.41-6.77-13.65-13.65-27.43-20.11-41.24a55.56,55.56,0,0,1-3.08-8.8c-2.25-9-1.83-18.44-1.81-27.6.12-12.21.62-24.6,3.57-36.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.91,159.45c-4.84,5.82-5.11,13.7-5.2,20.92-.22,14.69-.38,29.49,2,44a198.32,198.32,0,0,0,5,21.45c3,10.57,6,21.32,9.3,31.79,3.65,10.41,11.1,18.93,17.24,27.94,4.26,5.71,9.86,11.79,17.53,11.81-7.75.44-13.78-5.63-18.3-11.21-5.48-7.48-11.51-14.56-15.91-22.77-2.49-5-3.88-10.51-5.5-15.79-2.1-7.08-4.27-14.12-6.28-21.24a199.33,199.33,0,0,1-4.84-21.69c-2.33-14.67-1.76-29.56-1.14-44.32.38-7.22,1-15.35,6.17-20.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.2,183.62a145.37,145.37,0,0,0,8.39,43.74c2.56,7,5.18,14.3,5.57,21.87s.2,14.88,1.64,22.24c3.57,22,15.67,42.27,32.83,56.42,5.63,4.9,11.67,9.31,17.63,13.82-6.22-4.14-12.38-8.4-18.25-13.06a91.88,91.88,0,0,1-34.18-56.84c-1.38-7.38-1.14-15-1.48-22.46a50,50,0,0,0-1.83-10.85c-1-3.56-2.22-7.08-3.38-10.64a132.36,132.36,0,0,1-6.94-44.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.27,317.48c1.43,6,4.58,11.22,7.77,16.37s6.57,10,11.34,13.84c6.89,5.83,15.27,10.35,21.4,17.22a30.63,30.63,0,0,1,5,7.7c-6.53-10.68-18.46-15.57-27.73-23.39a45.71,45.71,0,0,1-11.39-14.58c-3-5.31-5.78-11-6.43-17.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.31,353.7c3.57,5.65,7.09,11.39,11.62,16.25,3,3.27,7.11,5.18,10.52,8.16,5.27,4.6,7.55,11.81,7.92,18.53-1.61-6.43-4-12.84-9.15-17.09-3.42-2.81-7.66-4.87-10.67-8.31a61.3,61.3,0,0,1-10.24-17.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.37,315.9a200.36,200.36,0,0,0-24.69,36.24c-5.26,9.5-8.58,21.43-18.71,27.06a16.36,16.36,0,0,1-10.78,2c7.47.49,13.89-4.55,17.79-10.48,4-6.09,6.45-13.12,9.93-19.56a137.75,137.75,0,0,1,26.46-35.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,104.21c-2.07-.19-2.83,3.58-3.43,5.12-.72,2.14-1.41,4.27-2,6.41a49.72,49.72,0,0,0-1.23,13.16A267.09,267.09,0,0,1,167.1,156a267.11,267.11,0,0,1-1.18-27.13c0-4.56.28-9.33,1.84-13.68a53.69,53.69,0,0,1,2.67-6.32c.87-1.57,2.25-5.3,4.52-4.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.18,121.89c.57,8.78.18,18.69-5.6,25.82,3.25-8.39,3.38-17.14,5.6-25.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.69,110.42a19,19,0,0,0-3.3,17.26,64.32,64.32,0,0,1,1.78,9.34,31.06,31.06,0,0,1-.59,9.53c-.12-6.41-1.46-12.26-3.14-18.43s-.14-13.78,5.25-17.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.88,103.83a19.39,19.39,0,0,0-3.52,7c-.79,2.59-.29,5.39-1.18,7.94-3.62,10,.64,21.13,7.52,28.8a77.15,77.15,0,0,0,5.68,5.61,27.57,27.57,0,0,1,4.21,4.36,3,3,0,0,1,.56,1.92,2.81,2.81,0,0,0-.73-1.8,31.38,31.38,0,0,0-4.51-3.93,61.31,61.31,0,0,1-6.1-5.32c-5.79-5.77-9.76-13.73-10-22-.13-3.44,1.18-6.75,2-10,.11-.57.15-1.34.2-1.91a15.42,15.42,0,0,1,5.84-10.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.15,107.79c.94,4.15,1.88,8.25,2.95,12.3,1.48,6.19,4.08,12,5.24,18.31,1,6.39.22,12.91-1.09,19.15-.21-8.39.1-16.73-2.83-24.69a76.25,76.25,0,0,1-4.27-25.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.47,104.15c-5,12.77,5,24.31,6.88,36.62.71,4.43,0,8.8-.89,13-.17-4.3-.11-8.58-1.14-12.57-3-11.73-12.87-25.18-4.85-37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.78,114.45c-1.89,4.32-5.64,8.1-6.52,12.7a48.39,48.39,0,0,0-.41,7.14,70.89,70.89,0,0,1-.56,7.38c-.81-5-1.67-9.76-1-14.89,1-5.07,5.12-8.68,8.49-12.33Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.72,97.56c5.16,5.17,16.91,4.78,16.91,4.78,12.9-.43-.32,2,31.21,2.24,15.69.13,23.54.2,34.57-.78a259.17,259.17,0,0,0,33.8-5.26c.33-1.86-.06-2.7-.48-3.12s-.93-.49-1.05-1,.63-.91.67-1.75-.9-1.14-1-2.25c0-.61.24-.64.48-1.75.2-1,.39-1.85,0-2.25s-1.48.42-3.46.39c-1.66,0-1.78-.69-3-.48-1.64.28-1.9,1.64-3.16,1.56-1.06-.07-1.13-1-2.31-1.17s-1.28.59-2.88,1-1.6-.19-3.27.1c-1.84.32-1.9,1-3.36,1.07s-1.57-.63-3.07-.58-1.53.64-3.07.87-1.93-.35-3.84-.39c-2.14,0-2,.71-4.23.78s-2.65-.72-5-.48c-1.34.13-1.34.41-2.69.48-1.85.11-2.05-.39-3.84-.39-2,0-2.12.63-4.13.59-1.62,0-1.55-.43-3.17-.49-2.13-.08-2.49.6-4.61.59-1.76,0-1.6-.48-3.56-.59-2.3-.13-2.55.52-5.09.49-1.82,0-1.79-.36-3.84-.39-2.26,0-2.26.38-4,.29-2.48-.11-2.75-.93-5-.88-1.78,0-1.66.56-3.37.59-2.39,0-2.69-1-5.09-1-2,0-2.07.73-3.74.49-2.07-.29-2.27-1.45-3.94-1.36-1.52.08-2,1.1-3.36.78-.85-.21-.75-.65-1.73-1-1.49-.5-2,.42-3.55,0-1.17-.32-1.2-1-2.31-1.07s-1.08.4-2,.39c-1.63,0-2-1.49-3.27-1.37a3.09,3.09,0,0,0-2.21,2.34c-.27,1.15.39,1.5.29,3.42a7.3,7.3,0,0,1-.38,2.14c-.44,1.27-.95,1.55-1,2.34A3,3,0,0,0,153.72,97.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.88,90.54a18.05,18.05,0,0,1,4.61.68c1.68.49,2.29,1,3.84,1.08,1.74.13,1.77-.4,3.36-.3,2.18.14,2.62,1.17,5.09,1.56,1.61.26,1.52-.17,3.17,0,3.78.4,4.66,2.69,7.1,2.25,1.57-.29,1.42-1.27,3.27-1.76s2.66.31,5.57.88a50.06,50.06,0,0,0,8,.29c2.65,0,4,0,5-.1,3.84-.38,4.8-1.2,7-.58a17.52,17.52,0,0,0,3.08.88,12.61,12.61,0,0,0,3.07,0c3.71-.39,3.85-1,6-1.08,2.94-.11,3.18,1.06,6,.78,2.19-.21,2-.88,4.13-1.07,2.89-.25,3.42.93,6.34.59,1.7-.21,1.84-.65,3.56-.69,2,0,2.2.54,3.84.49,2.26-.07,2.34-1.22,5-1.66,2.19-.36,2.39.39,4.61-.09,1.85-.41,1.89-1,3.55-1.17,1.83-.24,2.32.36,4,.19a7.92,7.92,0,0,0,3.65-1.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "158.91 93.1 158.91 94.96 157.85 95.86 157.85 97.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "162.33 93.73 162.33 95.59 161.28 96.49 161.28 97.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "167.1 94.96 167.1 96.82 166.04 97.72 166.04 99.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "171.62 95.23 171.62 97.09 170.57 97.99 170.57 99.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "176.58 95.86 176.58 97.72 175.52 98.62 175.52 100.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "180.52 97.09 180.52 98.95 179.46 99.85 179.46 101.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "184.94 97.37 184.94 99.22 183.88 100.13 183.88 101.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "241.69 97.09 241.69 98.95 242.75 99.85 242.75 101.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "247.45 96.64 247.45 98.5 248.51 99.4 248.51 100.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "252.7 95.86 252.7 97.72 253.76 98.62 253.76 100.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "257.75 94.96 257.75 96.82 258.8 97.72 258.8 99.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "261.5 94.28 261.5 96.13 262.56 97.03 262.56 98.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "265.1 93.4 265.1 95.25 266.16 96.16 266.16 97.66"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 189.26,
    y1: 97.37,
    x2: 188.1,
    y2: 101.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 193.46,
    y1: 97.83,
    x2: 192.31,
    y2: 102.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 197.88,
    y1: 97.83,
    x2: 196.73,
    y2: 102.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 201.9,
    y1: 97.83,
    x2: 200.75,
    y2: 102.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 205.18,
    y1: 98.15,
    x2: 204.99,
    y2: 102.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 210.02,
    y1: 98.15,
    x2: 209.83,
    y2: 102.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 214.63,
    y1: 98.15,
    x2: 214.44,
    y2: 102.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 218.87,
    y1: 98.19,
    x2: 219.71,
    y2: 102.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 223.74,
    y1: 98.19,
    x2: 224.58,
    y2: 102.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 228.44,
    y1: 97.8,
    x2: 229.27,
    y2: 102.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 232.72,
    y1: 97.17,
    x2: 233.55,
    y2: 101.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 236.87,
    y1: 97.33,
    x2: 237.71,
    y2: 101.98
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.71,416.25a45.3,45.3,0,0,0,22,.34,49.94,49.94,0,0,0,14.14-5.78c-.37,2.64-.75,6.36-1.13,9a42.54,42.54,0,0,1-11.64,4c-11,1.79-16,1.17-22.24-.24C221.5,419.73,220.05,417.69,220.71,416.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.65,411.81c-4.75,2.2-9.31,5-19.46,4.7a53.61,53.61,0,0,1-15.71-2.89c.86,2.53.66,6.07,1.52,8.6a55.45,55.45,0,0,0,14.05,1.68c11.69-.41,13.5-2,19.73-4.65C197.45,415.39,198.6,413.09,197.65,411.81Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatiala01);
export default __webpack_public_path__ + "static/media/PATIALA-01.c6dfdb3712481ff8520270e8be02ea33.svg";
export { ForwardRef as ReactComponent };